(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-save"] && !Shopify.designMode) return;
  try {
    (function(){
  function initBundle(root){
    if(root.dataset.ready) return;
    root.dataset.ready = '1';

    var customSel = (root.dataset.qtySelector || '').trim();
    var tiles = Array.prototype.slice.call(root.querySelectorAll('.ttp-tier'));
    var tiers = tiles.map(function(el){
      return { sets: parseInt(el.dataset.sets,10), el: el };
    }).sort(function(a,b){ return a.sets - b.sets; });

    var qsEl = null, qInput = null;

    function activeTier(q){ var t=null; tiers.forEach(function(x){ if(q>=x.sets) t=x; }); return t; }

    function render(qty){
      qty = Math.max(1, Math.floor(qty) || 1);
      var tier = activeTier(qty);
      tiers.forEach(function(x){
        var on = (x === tier);
        x.el.classList.toggle('is-active', on);
        x.el.setAttribute('aria-checked', on ? 'true':'false');
      });
    }

    function currentQty(){ return qInput ? (parseInt(qInput.value,10) || 1) : 1; }

    function setThemeQty(n){
      if(!qInput){ render(n); return; }
      qInput.value = n;
      if(qsEl){
        try{
          if(typeof qsEl.setValue === 'function') qsEl.setValue(String(n));
          if(typeof qsEl.updateButtonStates === 'function') qsEl.updateButtonStates();
          if(typeof qsEl.onQuantityChange === 'function') qsEl.onQuantityChange();
        }catch(e){}
      }
      qInput.dispatchEvent(new Event('input',{bubbles:true}));
      qInput.dispatchEvent(new Event('change',{bubbles:true}));
      render(n);
    }

    function findQty(){
      if(customSel){
        var ci = document.querySelector(customSel);
        if(ci){ qsEl = ci.closest('quantity-selector-component'); qInput = ci; return true; }
      }
      var scope = root.closest('.shopify-section') || document;
      var list = Array.prototype.slice.call(scope.querySelectorAll('quantity-selector-component'));
      if(!list.length) list = Array.prototype.slice.call(document.querySelectorAll('quantity-selector-component'));
      var pick = null;
      for(var i=0;i<list.length;i++){
        var el = list[i];
        if(el.querySelector('input[name="quantity"]') && !el.closest('[class*="sticky"],sticky-add-to-cart,cart-drawer,cart-items,quick-add-component')){ pick = el; break; }
      }
      if(!pick && list.length) pick = list[0];
      if(pick){ qsEl = pick; qInput = pick.querySelector('input[name="quantity"]'); }
      return !!qInput;
    }

    function bind(){
      if(!findQty()) return false;
      var read = function(){ render(currentQty()); };
      qInput.addEventListener('input', read);
      qInput.addEventListener('change', read);
      qInput.addEventListener('blur', function(){ setTimeout(read, 0); });
      var pm = qsEl ? qsEl.querySelectorAll('button[name="plus"],button[name="minus"]') : [];
      Array.prototype.forEach.call(pm, function(b){ b.addEventListener('click', function(){ setTimeout(read, 0); }); });
      read();
      return true;
    }

    tiers.forEach(function(x){ x.el.addEventListener('click', function(){ setThemeQty(x.sets); }); });

    if(!bind()){
      render(1);
      var tries = 0;
      var iv = setInterval(function(){ tries++; if(bind() || tries > 25){ clearInterval(iv); } }, 120);
    }
  }

  function initAll(scope){ (scope || document).querySelectorAll('.ttp-bundle').forEach(initBundle); }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else { initAll(); }

  if(!window.__ttpBundleBound){
    window.__ttpBundleBound = true;
    document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
    document.addEventListener('shopify:block:select', function(e){ initAll(e.target); });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["stock-indicator"] && !Shopify.designMode) return;
  try {
    (function() {

  function init(root) {

    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    var dataEl = root.querySelector('[data-stock-data]');
    var out = root.querySelector('[data-stock-output]');

    var redThreshold = 15;
    var yellowThreshold = 50;

    var lowLabel =
      root.getAttribute('data-low-label') || 'Low stock';

    var inLabel =
      root.getAttribute('data-instock-label') || 'In stock';

    var data = {};

    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var lastId = null;

    function render(variantId) {

      variantId = String(variantId || '');

      if (!variantId || variantId === lastId) return;

      lastId = variantId;

      var v = data[variantId];

      if (!v || !v.tracked) {
        out.innerHTML = '';
        return;
      }

      var qty = Number(v.qty) || 0;

      /*
       * 1-14 UNITS
       * RED
       */
      if (qty > 0 && qty < redThreshold) {

        var redPct =
          Math.max(4, Math.round(qty * 100 / redThreshold));

        out.innerHTML =
          '<div class="stock-indicator stock-indicator--red">' +

            '<p class="stock-indicator__text">' +
              '<strong>' + lowLabel + '</strong> ' +
              '<span>~ Only ' + qty + ' left</span>' +
            '</p>' +

            '<div class="stock-indicator__bar-track">' +
              '<div class="stock-indicator__bar-fill" ' +
                'style="width:' + redPct + '%">' +
              '</div>' +
            '</div>' +

          '</div>';

      }

      /*
       * 15-49 UNITS
       * YELLOW
       */
      else if (qty >= redThreshold && qty < yellowThreshold) {

        /*
         * Scale the bar between 15 and 50 units.
         * Minimum 20%, maximum 95%.
         */
        var yellowPct =
          20 + Math.round(
            ((qty - redThreshold) /
            (yellowThreshold - redThreshold)) * 75
          );

        out.innerHTML =
          '<div class="stock-indicator stock-indicator--yellow">' +

            '<p class="stock-indicator__text">' +
              '<strong>' + lowLabel + '</strong> ' +
              '<span>~ Only ' + qty + ' left</span>' +
            '</p>' +

            '<div class="stock-indicator__bar-track">' +
              '<div class="stock-indicator__bar-fill" ' +
                'style="width:' + yellowPct + '%">' +
              '</div>' +
            '</div>' +

          '</div>';

      }

      /*
       * 50+ UNITS
       * GREEN
       */
      else if (qty >= yellowThreshold) {

        out.innerHTML =
          '<div class="stock-indicator stock-indicator--in-stock">' +

            '<span class="stock-indicator__dot"></span>' +

            '<span>' + inLabel + '</span>' +

          '</div>';

      }

      /*
       * 0 UNITS
       * HIDE INDICATOR
       */
      else {

        out.innerHTML = '';

      }

    }

    /*
     * Find product form
     */
    function form() {

      var scope =
        root.closest(
          '.shopify-section, product-information, [id^="MainProduct"]'
        ) || document;

      return (
        scope.querySelector('form[action*="/cart/add"]') ||
        document.querySelector('form[action*="/cart/add"]')
      );

    }

    /*
     * Get currently selected variant
     */
    function currentId() {

      var f = form();

      if (f) {

        var idInput =
          f.querySelector(
            'input[name="id"], select[name="id"]'
          );

        if (idInput && idInput.value) {
          return idInput.value;
        }

      }

      /*
       * URL fallback
       */
      var m =
        window.location.search.match(/[?&]variant=(\d+)/);

      if (m) return m[1];

      return root.getAttribute('data-current');

    }

    /*
     * Initial render
     */
    render(currentId());

    /*
     * Horizon / Shopify variant events
     */
    document.addEventListener(
      'variant:change',
      function(e) {

        var variant =
          e.detail &&
          (e.detail.variant || e.detail);

        if (variant && variant.id) {
          render(variant.id);
        }

      }
    );

    /*
     * Variant input changes
     */
    document.addEventListener(
      'change',
      function(e) {

        if (
          e.target &&
          e.target.name === 'id'
        ) {
          render(e.target.value);
        }

      }
    );

    /*
     * Watch hidden variant ID input
     */
    var f = form();

    if (f) {

      var idInput =
        f.querySelector(
          'input[name="id"], select[name="id"]'
        );

      if (idInput) {

        var mo =
          new MutationObserver(function() {

            render(idInput.value);

          });

        mo.observe(
          idInput,
          {
            attributes: true,
            attributeFilter: ['value']
          }
        );

      }

    }

    /*
     * Safety-net polling
     */
    setInterval(
      function() {
        render(currentId());
      },
      400
    );

  }

  function initAll() {

    document
      .querySelectorAll('[data-stock-indicator]')
      .forEach(init);

  }

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );

  } else {

    initAll();

  }

  /*
   * Shopify section reload
   */
  document.addEventListener(
    'shopify:section:load',
    initAll
  );

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["trust-strip"] && !Shopify.designMode) return;
  try {
    (function(){
    function init(root){
      if(root.dataset.haloInit) return;
      var wrap = root.querySelector('.halo-trust__wrap');
      if(!wrap) return;
      root.dataset.haloInit = '1';

      var originals = Array.prototype.slice.call(wrap.querySelectorAll('.halo-trust__item'));
      var N = originals.length;
      if(N < 2) return;

      originals.forEach(function(it){
        var c = it.cloneNode(true);
        c.classList.add('halo-trust__clone');
        c.setAttribute('aria-hidden', 'true');
        wrap.appendChild(c);
      });

      var DELAY = 3000;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timer = null, jumping = false;

      function sliderActive(){ return getComputedStyle(wrap).display === 'flex'; }
      function step(){
        if(wrap.children.length < 2) return 0;
        return wrap.children[1].offsetLeft - wrap.children[0].offsetLeft;
      }

      function advance(){
        if(!sliderActive() || jumping) return;
        var s = step();
        if(s <= 0) return;
        var idx = Math.round(wrap.scrollLeft / s);
        var target = idx + 1;
        wrap.scrollTo({ left: target * s, behavior: 'smooth' });

        if(target >= N){
          jumping = true;
          var back = (target - N) * s;
          var reset = function(){
            wrap.scrollTo({ left: back, behavior: 'auto' });
            jumping = false;
          };
          if('onscrollend' in window){
            var h = function(){ wrap.removeEventListener('scrollend', h); reset(); };
            wrap.addEventListener('scrollend', h);
            setTimeout(function(){ if(jumping){ wrap.removeEventListener('scrollend', h); reset(); } }, 900);
          } else {
            setTimeout(reset, 550);
          }
        }
      }

      function start(){ if(reduce || timer) return; timer = setInterval(advance, DELAY); }
      function stop(){ if(timer){ clearInterval(timer); timer = null; } }
      function restart(){ stop(); start(); }

      wrap.addEventListener('pointerdown', stop);
      wrap.addEventListener('touchstart', stop, { passive: true });
      wrap.addEventListener('mouseenter', stop);
      wrap.addEventListener('mouseleave', start);
      wrap.addEventListener('touchend', function(){ setTimeout(restart, 600); }, { passive: true });
      wrap.addEventListener('pointerup', function(){ setTimeout(restart, 600); });
      document.addEventListener('visibilitychange', function(){ if(document.hidden) stop(); else start(); });

      start();
    }

    function initAll(){
      var nodes = document.querySelectorAll('.halo-trust');
      for(var i = 0; i < nodes.length; i++) init(nodes[i]);
    }
    if(document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
